import BaseService from './BaseService'

class ReportService extends BaseService {
  constructor () {
    super({path: 'cms', entity: 'report'})
  }
}

export default new ReportService()
